import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { i18nIntl, getInitials, getVerified, baseFake, getRemotedbUrl } from '../../../lib/ep.js';
import { size as _size } from 'lodash';

import ActionButton, { SecondaryButton } from '../../builder/ActionButton';
import ButtonCollection from '../../builder/ButtonCollection.js';
import FloatingLayer from '../../builder/FloatingLayer';
import { AlertMessage } from '../../builder/Message';
import SaveButton from '../../builder/SaveButton';
import SaveResponseMessage from '../../builder/SaveResponseMessage';
import SectionSubtitle from '../../builder/SectionSubtitle';
import SectionTitle from '../../builder/SectionTitle';
import Spinner from '../../builder/Spinner';
import TestPromoButton from './TestPromoButton';
import Tooltip from '../../builder/Tooltip.js';
import ActionLink from '../../builder/ActionLink.js';

const ActivatePromoButton = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props?.promotion?.Promotion ?? false;

	const [ agents, setAgents ] = useState([]);

	const [ state, setState ] = useState({
		display_layer:false,
		error_activate:false,
		display_layer_multistage:false,
		progress:false,
		forced_subscription:false,
		agent_selected:false,
		display_save_status:false,
		display_save_message:false,
		current_active:props.current_active,
	});

	const account_id = props.account_id; // TO DO: PASSAR L'ACCOUNT_ID DE L'AGENT ACTUAL
	const organizer_id = props.organizer_id; // TO DO: PASSAR L'ACCOUNT_ID DE L'AGENT ACTUAL
	const is_agent_admin = props.is_agent_admin; // TO DO: PASSAR L'ACCOUNT_ID DE L'AGENT ACTUAL

	const displayErrorActivate = (r) => {
		setState((state) => ({ ...state, error_activate:r }));
	};

	const openLayer = () => {
		if(agents.length > 0) {
			setState(state=>({...state,display_layer:true }));
		} else {
			setState(state=>({...state,display_layer:true, progress:true }));

			setTimeout(() => {
				$.get(getRemotedbUrl(`/accounts/getAgentsInAccount/${account_id}`), (r) => {
					if(r.status) {
						const agents = [];
						$.each(r.agents, (a, agent) => {
							var add_agent = agent.is_admin != undefined ? agent.is_admin : false;
							if(_size(agent.roles) > 0) {
								agent.roles.map((perm, p) => {
									if((perm.role == 2 && perm.label_id == organizer_id)){ //Admins OR Manager + Organizer
										add_agent = true;
									}
								});
							}

							if(add_agent){
								agents.push({
									avatar:agent.full_picture,
									id:agent.id,
									initials:getInitials(agent),
									name:agent.name + " " + agent.lastname,
								});
							}
						});
						setAgents(agents);
					}

					setState(state=>({...state, progress:false }));
				}, 'JSON');
			}, 2000);
		}
	}

	const closeLayer = () => {
		setState(state=>({...state, display_layer:false, progress:false, agent_selected:false }));
	}

	const toggleLayerMultistage = (forced_subscription = false) => {
		setState(state=>({...state, display_layer_multistage:!state.display_layer_multistage, forced_subscription:forced_subscription }));
	}

	const activatePromo = (cb) => {
		$.post(getRemotedbUrl('/promotions/check_activate/'+promotion.id), (r) => {
			if(r.status){
				let force_subscription = promotion.is_multistage;
				if(promotion.promotion_type_id == 45) force_subscription = true;

				//WL in Multi
				if(!props.has_available_subscription) {
					toggleLayerMultistage(force_subscription);
				} else {
					goToActivatePromotion();
				}
			}else{
				displayErrorActivate(r);
			}
			if(cb!=undefined)cb();
		},'JSON');
	}

	const goToActivatePromotion = () => {
		var has_activating_permissions = false;

		if(!window.account_type) {
			// is not a CORPORATE account
			has_activating_permissions = true;
		} else {
			// TO DO: REVISAR SI L'AGENT DE CORPORATE ACTUAL TÉ PERMISOS PER ACTIVAR PROMOS EN AQUESTA MARCA ORGANIZADORA. SI EN TÉ, CAL ENTRAR A L'IF SEGÜENT (POSAR has_activating_permissions A TRUE)
			has_activating_permissions = is_agent_admin;
			if(!has_activating_permissions){
				props.agent_roles.map((perm, p) => {
					if((perm.role == 2 && perm.label_id == organizer_id)){ //Admins OR Manager + Organizer
						has_activating_permissions = true;
					}
				});
			}
		}
		if(has_activating_permissions) {
			window.location.href = getRemotedbUrl(`/promotions/payment/${promotion.id}`);
		} else {
			openLayer();
		}
	}

	const toggleTarget = (id) => {
		setState(state=>({...state, agent_selected:(state.agent_selected != id) ? id : false }));
	}

	const send = (cb) => {
		// TO DO: ENVIAR UN MAIL (TEXTOS PER DEFINIR) AL EMAIL DE this.agents AMB ID = this.state.agent_selected
		$.post(getRemotedbUrl('/agents/require_activate_promotion/'), {
			info:baseFake(getVerified({
				pid:promotion.id,
				agent_id:state.agent_selected,
				organizer_id:organizer_id,
			})),
		}, (r) => {
			if(r.status) {
				setState((state) => ({
					...state,
					display_layer:false,
					agent_selected:false,
				}));
			}
			stateStatus(r, cb);
		}, 'JSON');
	};

	const stateStatus = (result, cb) => {
		setState((state) => ({
			...state,
			display_save_status:result.status ? 'ok' : 'ko',
			display_save_message:result.message,
		}));
		
		setTimeout(() => {
			setState((state) => ({
				...state,
				display_save_status:false,
				display_save_message:false,
			}));

			if(cb != undefined) cb();
		}, 2500);
	}

	const changeTest = (test) => {
		if(window.handlePromoProfile != undefined) window.handlePromoProfile.toggleTest();
		if(props.onTestChange != undefined) props.onTestChange(test);

		let delete_total_users = (promotion.promotion_type_id != undefined && promotion.promotion_type_id == 13) ? false : true;//pick Favorite
		if(delete_total_users) $('.total_participants_counter').html('0');
	}

	if(!promotion) return null;

	const ga_event = {}; 

	const draft_promotion = (props.status != undefined && props.status == 'draft') ? true : false;
	const has_media = (props.has_media != undefined) ? props.has_media : false;

	let type_label;
	let type_url;
	switch(promotion.promo_type) {
		case '2':
			type_label = "White Label Plan";
			type_url = 'wl';
			break;
		
		case '1':
			type_label = "Premium Plan";
			type_url = 'premium';
			break;

		case '0':
			type_label = "Basic Plan";
			type_url = 'basic';
			break;
	}

	const error_activate_reason = state.error_activate?.reason ?? false;
	let error_activate_msg, error_activate_link, error_activate_label = false;
	if(error_activate_reason){
		switch(error_activate_reason) {
			case 'draft_ended':
				error_activate_msg = "The promotion can't be activated because the end of publication date is past. Please check the promotion dates configuration.";
				error_activate_link = `/promotions/builder/${promotion.id}#dates`;
				error_activate_label = "Edit dates";
				break;
			default:
				error_activate_msg = "Unexpected Error";
				break;
		}
	}
	const disable_individual_payment = (account_id > 1314725) ? true : false;
	return (
		<>
			<div class="activate_promo">
				{(!promotion.test) && (
					props?.link_element ? (
						<ActionLink
						onClick={(e,cb) => activatePromo(cb)}
						_gaEvent={ga_event}
						type="main"
					>{props.children ?? "Activate promotion"}</ActionLink>
					):(
					<SaveButton
						onClick={(e,cb) => activatePromo(cb)}
						_gaEvent={ga_event}
						type="main"
					>{props.children ?? "Activate promotion"}</SaveButton>
					)
				)}

				{(draft_promotion) && (
					<TestPromoButton
						promotion={promotion}
						has_media={has_media}
						onChangeTest={changeTest}
						intl={props.intl}
						current_active={state.current_active}
					/>
				)}

				{(promotion.test) && (
					<ActionButton
						tooltip={<Tooltip position="bottom" with_icon={false}>Disable the test mode to activate and publish the promotion.</Tooltip>}
						disabled={true}
					>Activate promotion</ActionButton>
				)}
			</div>

			{(state.display_layer) && (
				<FloatingLayer _class={{size:'small'}} backButton={closeLayer}>
					<div>
						<SectionTitle>Only managers can activate promotions. Please select a manager to send an activation request.</SectionTitle>

						{(state.progress) && (
							<div class="gui_pos_rel" style={{minHeight:'100px'}}>
								<Spinner>Loading agents. Please, wait.</Spinner>
							</div>
						)}

						{(!state.progress && agents.length > 0) && (
							<ul class="gui_user_selector">
								{agents.map((target, t) => {
									const selected = (state.agent_selected == target.id) ? true : false;

									return (
										<li key={t} class={'is_linked_element' + ((selected) ? ' selected' : '')} onClick={() => toggleTarget(target.id)}>
											<div>
												<span class="user_avatar">
													{(target.avatar != undefined) ? (
														<span style={{backgroundImage:'url(' + target.avatar + ')', backgroundSize:'contain', width:'30px', height:'30px', display:'inline-block'}} />
													) : (
														<span class="gui_emulated_avatar" style={{background:'rgba(0, 0, 0, 0.1)'}}><span class="blackColor">{target.initials}</span></span>
													)}
												</span>

												<strong>{target.name}</strong>
											</div>

											<ButtonCollection>
												<SecondaryButton
													color={(selected) ? 'blue' : 'black'}
												>{(selected) ? "Selected" : "Select"}</SecondaryButton>
											</ButtonCollection>
										</li>
									)
								})}
							</ul>
						)}

						{(!state.progress && agents.length == 0) && (
							<AlertMessage
								_class={{ other:'in_top in_bottom' }}
							>
								<p>{i18n("There is no agent with activation capabilities for this organizing brand.")}</p>
							</AlertMessage>
						)}

						<ButtonCollection in_floating={true}>
							<SaveButton
								disabled={(state.agent_selected === false) ? true : false}
								onClick={(e,cb) => send(cb)}
							>Send request</SaveButton>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}

			{(state.display_layer_multistage && state.forced_subscription) && (
				<FloatingLayer _class={{size:'small'}} backButton={() => toggleLayerMultistage()}>
					<div class="without_actions">
						<SectionTitle>Promotion activation</SectionTitle>

						<SectionSubtitle
							autotranslate={false}
						>{props.intl.formatMessage({ id:"To activate this promotion you must purchase a {type}." }, { type:i18n(type_label) })}</SectionSubtitle>

						<SectionSubtitle
							autotranslate={false}
						><strong>{i18n("You must keep the plan active for the entire duration of the promotion.")}</strong></SectionSubtitle>

						<div style={{ display:'flex', justifyContent:'center', alignItems:'center', minHeight:'6em' }}>
							<ButtonCollection>
								<ActionButton
									_href={`${window.panel_url}plans/add/${type_url}/?activate`}
									autotranslate={false}
								>{props.intl.formatMessage({ id:"Purchase {type}" }, { type:i18n(type_label) })}</ActionButton>
							</ButtonCollection>
						</div>
					</div>
				</FloatingLayer>
			)}

			{(state.display_layer_multistage && !state.forced_subscription) && (
				<FloatingLayer _class={{size:'small'}} backButton={() => toggleLayerMultistage()}>
					<div>
						<SectionTitle>Promotion activation</SectionTitle>

						<SectionSubtitle autotranslate={false}>{props.intl.formatMessage({ id:"You can activate this promotion with a {type}." }, { type:i18n(type_label) })}</SectionSubtitle>

						<SectionSubtitle>The plan allows you to activate and manage unlimited promotions.</SectionSubtitle>

						<SectionSubtitle autotranslate={false}><strong>{i18n("You must keep the plan active for the entire duration of the promotion.")}</strong></SectionSubtitle>

						<div style={{ display:'flex', justifyContent:'center', alignItems:'center', minHeight:'6em' }}>
							<ButtonCollection>
								<ActionButton
									_href={`${window.panel_url}plans/add/${type_url}/?activate`}
									autotranslate={false}
								>{props.intl.formatMessage({ id:"Purchase {type}" }, { type:i18n(type_label) })}</ActionButton>
							</ButtonCollection>
						</div>
						
						{(!disable_individual_payment) && (
							<ButtonCollection in_floating={true} _class={{other:'gui_flex_center'}}>
								<FormattedMessage
									id="You can also {link} independently, without a plan."
									values={{ link:<ActionLink onClick={() => goToActivatePromotion()}>purchase this promotion</ActionLink> }}
									/>
							</ButtonCollection>
						)}
					</div>
				</FloatingLayer>
			)}

			{(state.error_activate) && (
				<FloatingLayer _class={{size:'small'}} enable_close={false}>
					<div>
						<SectionTitle _class={{other:'is_not_padded redIcon',icon:'knk-alert'}}>Warning</SectionTitle>
						<SectionSubtitle>{error_activate_msg}</SectionSubtitle>

						<ButtonCollection in_floating={true}>
							{(error_activate_link) && (
								<ActionButton
									_href={`${error_activate_link}`}
									>{error_activate_label}</ActionButton>
							)}

							<SecondaryButton
								onClick={() => setState(state=>({...state,error_activate:false}))}
							>Close</SecondaryButton>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}

			{(state.display_save_message) && (
				<SaveResponseMessage
					status={state.display_save_status}
					message={<span dangerouslySetInnerHTML={{ __html:state.display_save_message}} />}
				/>
			)}
		</>
	)
	
}

export default injectIntl(ActivatePromoButton);